import { dateFns } from '../helpers';
import { subDays } from 'date-fns';

export const defaultDate = {
    from: new Date('01-01-2018'),
    to: new Date(),
    today: [new Date(), new Date()],
    yesterday: [dateFns.addDays(new Date(), -1), dateFns.addDays(new Date(), -1)],
    lastSevenDays: [subDays(new Date(), 6), new Date()],
    lastMonth: [dateFns.startOfMonth(new Date()), new Date()],
};

// is used by CancellationsFilters.js
export const setTextDatePicker = (className, text, color) => {
    const elementPicker = document.getElementsByClassName(className);
    if (elementPicker[0]?.innerText) {
        elementPicker[0].innerText = text;
        color && (elementPicker[0].style.color = color);
    }
};
